// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_base_container__qIkxe","modalClose":"styles_base_modalClose__a129t","floatingClose":"styles_base_floatingClose__UaC0F"};